define(function(require) {
	return {
        //session keys
        NAMESPACE: 'PROCESSMANAGER',
        ACTIVE_PROCESS: 'ACTIVE_PROCESS',
        PROCESS_STATE: 'PROCESS_STATE',
        PROCESS_PARAMS:'PROCESS_PARAMS',
        RETURN_URL: 'RETURN_URL',
        PROCESS_INTERRUPTED: 'PROCESS_INTERRUPTED',
        AUTO_RETURN: 'AUTO_RETURN',
        PROMPT_TYPE: 'INFO',
        DEFAULT_PROMPT_MSG: i18n.t('CIVICS.COMMON.CONTINUE_PROCESS'),
        PROCESS_NAMES: {
            FORGOTPASSWORD: 'FORGOTPASSWORD',
            FORGOTUSERNAME: 'FORGOTUSERNAME',
            INVITATION: 'INVITATION',
            REGISTER: 'REGISTER'
        },
        INVITE_STEPS: {
            INIT: 'INIT',
            LOGIN: 'LOGIN',
            POSTLOGIN: 'POSTLOGIN',
            PROFILESELECTION: 'PROFILESELECTION',
            ACCEPT: 'ACCEPTINVITE',
            POSTACCEPT: 'POSTACCEPT'
        },
        INTERRUPTION_TYPES: {
            FORGOTPASSWORD: 'FORGOTPASSWORD',
            FORGOTUSERNAME: 'FORGOTUSERNAME',
            REGISTER: 'REGISTER',
            LOGOUTANDRETURNTOLOGIN: 'LOGOUTANDRETURNTOLOGIN',
            EXPIREDPASSWORD: 'EXPIREDPASSWORD'
        },
        PROMPT_MESSAGE: {
            INVITATION: i18n.t('CIVICS.COMMON.PROCESS_MANAGER.INVITE_PROMPT')
        }
    }
})